import { render, staticRenderFns } from "./LogoutPage.vue?vue&type=template&id=d6812882&scoped=true"
import script from "./LogoutPage.vue?vue&type=script&lang=js"
export * from "./LogoutPage.vue?vue&type=script&lang=js"
import style0 from "./LogoutPage.vue?vue&type=style&index=0&id=d6812882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6812882",
  null
  
)

export default component.exports